<template>
  <div v-if="lookups && qualification">
    <SubHeader title="Stage 2" />

    <b-row class="my-1">
      <b-col md="3" class="label">
        <label :for="'qualifierId-' + index">randd Qualifier</label>
      </b-col>
      <b-col md="9">
        <b-form-select
          :id="'qualifierId-' + index"
          :options="lookups.qualifiers"
          v-model="qualification.qualifierId"
          value-field="id"
          text-field="fullName"
          :disabled="qualification.id == 0"
        >
          <template v-slot:first>
            <b-form-select-option :value="null" >-</b-form-select-option>
          </template>
        </b-form-select>
      </b-col>
    </b-row>

    <b-row class="my-1">
      <b-col md="3" class="label">
        <label :for="'generatorId' + index">randd Generator</label>
      </b-col>
      <b-col md="9">
        <b-form-select
          :id="'generatorId' + index"
          :options="lookups.generators"
          v-model="qualification.generatorUserId"
          value-field="id"
          text-field="fullName"
          :disabled="qualification.id == 0"
        >
          <template v-slot:first>
            <b-form-select-option :value="null" >-</b-form-select-option>
          </template>
        </b-form-select>
      </b-col>
    </b-row>

    <b-row class="my-1">
      <b-col md="3" class="label">
        <label :for="'contractResponsibilityId' + index">Contract Responsibility</label>
      </b-col>
      <b-col md="9">
        <b-form-select
          :id="'contractResponsibilityId' + index"
          :options="lookups.directors"
          v-model="qualification.contractResponsibilityId"
          value-field="id"
          text-field="fullName"
          :disabled="qualification.id == 0"
        >
          <template v-slot:first>
            <b-form-select-option :value="null" >-</b-form-select-option>
          </template>
        </b-form-select>
      </b-col>
    </b-row>

    <b-row class="my-1">
      <b-col md="3" class="label">
        <label :for="'contractNotes' + index">Contract notes / T&amp;C changes</label>
      </b-col>
      <b-col md="9">
        <b-form-textarea
          :id="'contractNotes' + index"
          v-model="qualification.contractNotes"
          :disabled="qualification.id == 0">
        </b-form-textarea>
      </b-col>
    </b-row>


    <b-row class="my-1">
      <b-col md="3" class="label">
        <label :for="'contractSentDate' + index">Contract Sent Date</label>
      </b-col>
      <b-col md="9">
         <b-form-datepicker :id="'contractSentDate' + index" v-model="qualification.contractSentDate"
         :date-format-options="{
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
          }"
          locale="en-GB"
          :disabled="qualification.id == 0 || qualification.clientStatusId == 1 || qualification.clientStatusId == 3" />
      </b-col>
    </b-row>

    <b-row class="my-1">
      <b-col md="3" class="label">
        <label :for="'unbookedNotes' + index"> Unbooked notes </label>
      </b-col>
      <b-col md="9">
        <b-form-textarea
          :id="'unbookedNotes' + index"
          v-model="qualification.unbookedNotes"
          rows="3"
          :disabled="qualification.id == 0"
        ></b-form-textarea>
      </b-col>
    </b-row>


    <b-row class="my-1">
      <b-col md="3" class="label">
      </b-col>
      <b-col md="9">
         <b-button type="submit" variant="danger" class="margin-right" @click="noFurther" :disabled="qualification.id == 0">
          <font-awesome-icon icon="times" /> No Further
        </b-button>
      </b-col>
    </b-row>

    <b-row class="my-1">
      <b-col md="3">
        <label for="input-none"></label>
      </b-col>
      <b-col md="9">
        <b-button type="submit" variant="success" class="margin-right" @click="save" :disabled="qualification.id == 0">
          <font-awesome-icon icon="save" /> Save
        </b-button>
        <b-button type="reset" variant="danger" @click="reset" :disabled="qualification.id == 0">
          <font-awesome-icon icon="times" /> Cancel Changes
        </b-button>
      </b-col>
    </b-row>

    <b-row class="my-1">
        <b-col md="3">
        </b-col>
        <b-col md="6">
          <Feedback ref="saveFeedback"/>
        </b-col>
      </b-row>
  </div>
</template>

<script>
import SubHeader from "@/components/shared/SubHeader.vue";
//import Multiselect from "vue-multiselect";
import CompanyService from '@/services/Company.service'
import Feedback from "@/components/shared/Feedback.vue";

export default {
  components: { SubHeader,  Feedback },
  props: {
    initialQualification: Object,
    lookups: Object,
    index: Number
  },
  mounted() {
    if (this.initialQualification && this.qualification == null) {
      this.qualification = {...this.initialQualification};
    }
     
    this.fixQualificationLookup();
    this.fixGeneratorLookup();
  },
  watch: {
    initialCompany: function() {
      this.qualification = {...this.initialQualification};
    },
  },
  data() {
    return {
      qualification: null
    };
  },
  methods: {
    reset() {
      this.qualification = {...this.initialQualification}
    },
    fixQualificationLookup()
    {
      var qualifierFound = false;
      var qualifierID = this.qualification.qualifierId;
      if (qualifierID != null){
        var qualifierFull = this.qualification.qualifierString + " - Deleted";
        this.lookups.qualifiers.forEach(function(qualifier) {
          if (qualifierID == qualifier.id)
          {
            qualifierFound = true;
          }
        });
        if (qualifierFound == false)
        {
            const newObj = { id: qualifierID, fullName: qualifierFull };
            this.lookups.qualifiers.push(newObj);
        }
      }
      
    },
    fixGeneratorLookup()
    {
      console.log(this.qualification);
      var generatorFound = false;
      var generatorID = this.qualification.generatorUserId;
      if (generatorID != null){
        var generatorFull = this.qualification.generatorUserString + " - Deleted";
        this.lookups.generators.forEach(function(generator) {
          if (generatorID == generator.id)
          {
            generatorFound = true;
          }
        });
        if (generatorFound == false)
        {
            const newObj = { id: generatorID, fullName: generatorFull };
            this.lookups.generators.push(newObj);
        }
      }
      
    },
    save() {

      CompanyService.saveCompanyQualifications(this.qualification).then(() => {
        this.$refs.saveFeedback.showSuccess("Save Successful");
        this.$parent.$parent.$parent.$parent.$parent.loadData();
      })
    },
    noFurther() {
      this.qualification.isCompleted = true;
      this.save();
    }
  }
};
</script>

<style scoped>
.label {
  text-align: right;
}
.label > label {
  margin-top: 6px;
}
</style>
